import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';

/**
 * This component should wrap the content that you wish to use as the base layer. All overlayed elements will be atop this element.
 */
import { jsx as _jsx } from "react/jsx-runtime";
function PositionedOverlayAnchor(_ref) {
  let {
    block,
    position,
    children,
    className,
    offsetTop = 0,
    offsetBottom = 0,
    offsetLeft = 0,
    offsetRight = 0,
    ...rest
  } = _ref;
  const hasOffSet = offsetTop > 0 || offsetBottom > 0 || offsetLeft > 0 || offsetRight > 0;
  const rootClassName = clsx({
    'positioned-overlay-anchor': true,
    'positioned-overlay-anchor-block': block,
    [position]: true
  }, className);
  const getChildren = () => {
    let anchorChildren = children;
    if (hasOffSet) {
      const offsetVerticalClassNames = clsx({
        ['offset-top-' + offsetTop]: offsetTop > 0,
        ['offset-bottom-' + offsetBottom]: offsetBottom > 0
      });
      const offsetHorizontalClassNames = clsx({
        ['offset-left-' + offsetLeft]: offsetLeft > 0,
        ['offset-right-' + offsetRight]: offsetRight > 0
      });
      anchorChildren = /*#__PURE__*/_jsx("div", {
        className: offsetVerticalClassNames,
        children: /*#__PURE__*/_jsx("div", {
          className: offsetHorizontalClassNames,
          children: children
        })
      });
    }
    return anchorChildren;
  };
  return /*#__PURE__*/_jsx("div", {
    "data-cmp": "positionedOverlayAnchor",
    className: rootClassName,
    ...rest,
    children: getChildren()
  });
}
export default PositionedOverlayAnchor;